import React from 'react';
import { useTranslations } from '../context/TranslationContext';

interface Language {
  code: 'en' | 'it';
  label: string;
}

const LanguageSwitcher: React.FC = () => {
  const { currentLanguage, changeLanguage, t } = useTranslations();
  const availableLanguages: Language[] = [
    { code: 'en', label: 'EN' },
    { code: 'it', label: 'IT' },
  ];

  const handleLanguageSelect = (code: 'en' | 'it') => {
    changeLanguage(code);
  };

  return (
    <div className="inline-flex items-center gap-1 rounded-full border border-white/15 bg-deep-space/80 p-1" aria-label={t('language_selector')}>
      {availableLanguages.map((lang) => (
        <button
          key={lang.code}
          className={`min-h-11 min-w-11 rounded-full px-3 py-1.5 text-sm font-bold leading-5 transition-colors duration-200
            ${currentLanguage === lang.code
              ? 'bg-white text-void-blue shadow-sm'
              : 'text-gray-400 hover:bg-white/5 hover:text-white'
            }`}
          onClick={() => handleLanguageSelect(lang.code)}
          aria-pressed={currentLanguage === lang.code}
        >
          {lang.label}
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
